import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";

import { App } from "@/App";
import { theme } from "@/theme";
import { queryClient } from "@/lib/queryClient";
import { useAuthStore } from "@/stores/auth";
import { useUiStore } from "@/stores/ui";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@/theme/global.css";

function AppBootstrap() {
  const loadUser = useAuthStore((s) => s.loadUser);
  const colorScheme = useUiStore((s) => s.colorScheme);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <MantineProvider theme={theme} defaultColorScheme={colorScheme}>
      <Notifications position="top-right" />
      <ModalsProvider>
        <App />
      </ModalsProvider>
    </MantineProvider>
  );
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/app">
        <AppBootstrap />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
